/** @format */

import PropTypes from "prop-types";
import { memo, forwardRef, ReactNode } from "react";
import Box from "@mui/material/Box";
import { StyledScrollbar, StyledRootScrollbar } from "./style";

interface ScrollbarProps {
	children?: ReactNode;
	sx?: any;
}

const Scrollbar = forwardRef<unknown, ScrollbarProps>(
	({ children, sx, ...other }, ref) => {
		const userAgent =
			typeof navigator === "undefined" ? "SSR" : navigator.userAgent;

		const mobile =
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
				userAgent
			);

		if (mobile) {
			return (
				<Box ref={ref} sx={{ overflow: "auto", ...sx }} {...other}>
					{children}
				</Box>
			);
		}

		return (
			<StyledRootScrollbar>
				<StyledScrollbar
					scrollableNodeProps={{
						ref,
					}}
					clickOnTrack={false}
					sx={sx}
					{...other}>
					{children}
				</StyledScrollbar>
			</StyledRootScrollbar>
		);
	}
);

Scrollbar.propTypes = {
	children: PropTypes.node as any,
	sx: PropTypes.object,
};

export default memo(Scrollbar);
